module.exports = __webpack_public_path__ + "media/excellusbcbs-app-page@lg-6b25a26b9d1b4bfb1e3f8b6afb84d33c.jpg";